import React from 'react'

function TestimonialsPage() {
  return (
    <div>TestimonialsPage</div>
  )
}

export default TestimonialsPage